import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Button, Tabs, Pagination, Progress, message, Icon, Empty, Modal} from 'antd';
import BaseComponent from "../../../../base/BaseComponent";
import FaceModular from "./compontent/FaceModular";
import FaceSeach from './compontent/FaceSeach';
import {uuid} from "../../../../utils";
import Titlepicfile from "../../../components/titlepicfile/Titlepicfile";
import {Scrollbars} from "react-custom-scrollbars";
import {HEADER_HEIGHT} from "../../../../constants";

const {TabPane} = Tabs;
export default class RelationshipMap extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            tabList: [{name: '全部人脸', id: "-1"}, {name: '未标识人脸', id: "0"}, {name: '已标识人脸', id: "1"}],
            total: 0,
            params: {
                labeled: '-1',//当前选中的
                page: 1, //第几页
                page_size: 21, //一页多少个
                name: ''//搜索的名称
            },
            dataSource: [],//列表的数据
            initialized: false,//按钮是否可点击，默认false 可以点击。
            data: 0,//进度条的数字
            searchList: [],//上传的数据
            status: 'add',//状态  add 新增 edit 编辑  走的接口不一样
            facereconitionKey: '',
            newSecondSelectColor :this.sysConfigGetValueByKey("NewMenuBg", "#0050B3")
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {


    }

    componentWillMount() {

    }

    componentDidMount() {
        this.getFaceList();
        this.initFaceMeta();//获取人脸初始化
    }

    render() {
        let height = document.body.clientHeight - HEADER_HEIGHT - 32;
        return (
            <div style={{background: '#ffffff', margin: "15px 0 15px 15px", borderRadius: 5, maxHeight: height}}>
                <div style={{paddingTop: '32px'}}>
                    <FaceSeach
                        ref = {(ref) => this.faceSearch = ref}
                        search={(data) => {
                            this.searchText(data)
                        }}
                        searchCallBack={(info) => {
                            this.searchPic(info)
                        }}>
                    </FaceSeach>
                </div>
                {this.state.searchList.length > 0 ? this.renderSeachPic() : this.renderProgress()}
                {this.renderTable()}
                {this.renderList()}
                {this.renderFoot()}
            </div>

        )
    }
    //以图搜图
    searchPic = (info) =>{
         window.loading.show();
        let list = [info.file];
        this.state.params.page = 1;
        this.state.page_size = 21;
        this.state.searchList = list;
        this.state.params.name = '';
        this.state.dataSource = [];
        this.state.total = 0;
        this.faceSearch.init();
        this.setState({}, () => {
            this.getSearchList()
        })
    };
    //搜文字
    searchText = (data) =>{
        this.state.params.page = 1;
        this.state.page_size = 21;
        this.state.params.name = data;
        this.state.searchList = [];
        this.setState({}, () => {
            this.getFaceList()
        })
    };

    //以图搜图的展示
    renderSeachPic() {
        let {searchList} = this.state;

        return (
            <div style={{display: 'flex', padding: '32px 32px 0px 32px'}}>
                <div>
                    {searchList.map((item, index) => {
                        let src = item.response.data.path;
                        return (
                            <Titlepicfile style={{width: '176px', height: '99px'}} key={index} src={src}/>
                        )
                    })}
                </div>
                <div style={{
                    marginLeft: "20px",
                    marginTop: "40px",
                    color: this.state.newSecondSelectColor,
                    display: "flex",
                    alignItems: "end",
                    cursor: 'pointer'
                }}
                     onClick={() => {
                         this.state.params.page = 1;
                         this.state.page_size = 21;
                         this.state.searchList = [];
                         this.setState({searchList: []}, () => {
                             this.getFaceList()
                         })
                     }}>删除
                </div>
            </div>
        )
    }

    //全库扫描按钮
    renderProgress() {
        let btnStatus = this.sysConfigGetValueByKey("face_recognition.all_pictures.scan.enable", "true");
        return (
            <div style={{width: '100%', padding: '24px 32px 0px 32px'}}>
                {btnStatus === "true" ? <div style={{display: 'flex'}}>
                    <div style={{marginTop: 7}}>
                        <Button type="primary" disabled={this.state.initialized} onClick={() => {
                            this.state.initialized = true;
                            this.init()
                        }}>全库扫描</Button>
                    </div>
                    <div style={{marginTop: 10, marginLeft: 10, width: 400}}>
                        <Progress percent={this.state.data}
                                  status={this.state.data < 100 ? "active" : "normal"}/>
                    </div>
                </div> : null}
            </div>
        )
    }

    //列表显示翻页  搜索以下拉的形式展示
    renderList() {
        let {searchList} = this.state;
        let height = document.body.clientHeight - HEADER_HEIGHT - 72 - 63 - 60 - 131;
        return (
            <div>
                {searchList && searchList.length ?
                    <div>
                        {this.state.total ? <div style={{
                            textAlign: "end",
                            paddingRight: "20px",
                            marginBottom:'15px',
                            color: 'rgba(0, 0, 0, 0.65);'
                        }}>{`已检索到${this.state.total}张相关人脸数据`}</div> : null}
                        {this.renderData()}
                    </div> : this.renderData()}
            </div>
        )
    }

    //列表
    renderData() {
        let {searchList} = this.state;
        let height;
        if(searchList&&searchList.length){
             height = document.body.clientHeight - HEADER_HEIGHT - 32 - 72 - 63 - 60 -130;
        }else{
             height = document.body.clientHeight - HEADER_HEIGHT - 32 - 72 - 63 - 60 - 64;
        }

        return (

            <Scrollbars autoHeight
                        autoHide
                        key={this.state.facereconitionKey}
                        autoHeightMax={height}
            >{
                this.state.dataSource && this.state.dataSource.length ? <div style={{
                    display: 'grid',
                    justifyContent: 'space-between',
                    columnGap: '16px',
                    rowGap: '16px',
                    padding: '0px 32px 32px 32px',
                    gridTemplateColumns: ' repeat(auto-fill, 168px)'
                }}>
                    {this.state.dataSource && this.state.dataSource.length && this.state.dataSource.map((item, index) => {
                        return (<FaceModular doubleClick={(data) => {
                            this.doubleClick(item, data)
                        }}
                                             key={item.face_image_url}
                                             src={item.face_image_url}
                                             count={item.count}
                                             newLabel={item.newlabel}
                                             oldLabel={item.oldLabel}
                                             isShowInput={item.isShowInput}
                                             close={() => {
                                                 this.close(item)
                                             }}
                                             name={item.label}
                                             onPressEnter={() => {
                                                 this.onPressEnter(item)
                                             }}
                                             editLabel={(data) => {
                                                 this.editLabel(item, data)
                                             }}
                                             onChangeText={(e) => {
                                                 this.onChangeText(item, e)
                                             }}
                        ></FaceModular>)
                    })}
                </div> : <Empty style={{padding: '32px'}}/>
            }</Scrollbars>
        )
    }

    renderTable() {
        return (
            <div><Tabs activeKey={this.state.params.labeled} tabBarStyle={{
                padding: '0px 20px'
            }} style={{margin: '12px 0px'}} className="interval" onChange={(data) => {
                this.state.params.labeled = data;
                this.state.params.page = 1;
                this.state.page_size = 21;
                this.state.total = 0;
               this.state.dataSource=[];
                this.setState({}, () => {
                    if (this.state.searchList && this.state.searchList.length) {
                        this.getSearchList()
                    } else {
                        this.getFaceList()
                    }
                })
            }}>
                {this.state.tabList && this.state.tabList.length && this.state.tabList.map((item, index) => {
                    return (
                        <TabPane tab={item.name} key={item.id}></TabPane>
                    )
                })}
            </Tabs></div>

        )
    }
    renderFoot(){
        return(
            <div>
                {this.state.dataSource && this.state.dataSource.length && !this.state.searchList.length > 0 ? <div
                    style={{
                        padding: '10px 32px',
                        height: '64px',
                        lineHeight: '64px',
                        display: 'flex',
                        justifyContent: 'end',
                        borderTop: '1px solid rgba(0, 0, 0, 0.15)',
                        alignItems: "center"
                    }}>
                    <Pagination
                        // showQuickJumper
                        defaultCurrent={this.state.params.page}
                        current={this.state.params.page}
                        pageSize={this.state.params.page_size}
                        total={this.state.total}
                        showTotal={total => `共 ${total} 条`}
                        // showSizeChanger
                        onShowSizeChange={(page, pageSize) => {
                            this.onChange(page, pageSize);
                        }}
                        onChange={(page, pageSize) => this.onChange(page, pageSize)}/>
                </div> : null}
            </div>
        )
    }

    //获取列表
    getFaceList() {
        this.request({
            url: '/cm-sites-storage-management/face/list',
            method: 'post',
            body: this.state.params,
            contentType: "json",
            callBack: async (data) => {
                let Data = data;
                if (Data && Data.list.length) {
                    Data.list.forEach((item, i) => {
                        item.key = i;
                        item.checked = false;
                        item.isShowInput = false
                    });
                    this.state.dataSource = Data.list;
                    this.state.total = Data.total;
                } else {
                    this.state.dataSource = [];
                    this.state.total = 0;
                }
                this.setState({});
            }
        });
    }

    close = (item) => {
        item.newlabel = [];
        item.oldLabel = '';
        item.isShowInput = false;
        this.setState({})
    };
    editLabel = (item, data) => {
        let content = <div>修改名称后已命名为<span style={{color: this.state.newSecondSelectColor}}>{item.label}</span>的图片标签名称都将改变</div>
        Modal.confirm({
            title: '您确定要修改名称吗？',
            content: content,
            okText: '确认',
            cancelText: '取消',
            onOk: () => {
                this.doubleClick(item, data)
            }
        });
    };

    //双击时间
    doubleClick(item, data) {
        let {dataSource} = this.state;
        dataSource && dataSource.length && dataSource.forEach((i, index) => {
            if (item.face_id === i.face_id) {
                i.isShowInput = true;
            } else {
                i.isShowInput = false;
            }
        });
        if (data === 'edit') {
            item.oldLabel = JSON.parse(JSON.stringify(item.label));
        }
        this.state.status = data;
        this.setState({}, () => {
        });
    }

    //获取人脸初始化状态 是否可以初始化
    initFaceMeta() {
        this.request({
            url: '/cm-sites-storage-management/face/meta',
            method: 'get',
            callBack: async (data) => {
                if (data) {
                    if (data.initialized) {
                        this.initProgress()
                    }
                    this.setState({initialized: data.initialized});
                }
            }
        });
    }

    //获取进度条的数值
    initProgress() {
        let that = this;
        this.request({
            url: '/cm-sites-storage-management/face/initialized/progress',
            method: 'get',
            callBack: async (data) => {
                if (data) {
                    let num = data;
                    if (num < 100) {
                        setTimeout(function () {
                            num++;
                            that.initProgress();
                        }, 15000)  //15秒调取一次
                    }
                    this.setState({
                        initialized: num === 100 ? false : true,//进度条100的时候，按钮可以再次点击
                        data: num
                    });
                }
            }
        });
    }

    //开始初始化
    init() {
        this.request({
            url: '/cm-sites-storage-management/face/initialized',
            method: 'get',
            callBack: async (data) => {
                this.initProgress()
            }
        });
    }

    //页数条数发生改变
    onChange(e, pageSize) {
        this.state.params.page = e;
        this.state.params.page_size = pageSize;
        this.state.facereconitionKey = uuid();
        this.setState({}, () => {
            this.getFaceList();
        });
    }

    //输入标签
    onChangeText = (item, e) => {
        item.oldLabel = e.target.value;
        item.newlabel = [e.target.value];
        this.setState({});
    };
    //保存标签
    onPressEnter = (item) => {
        let url = '';
        let param = {
            "face_id": item.face_id,
            "label": item.newlabel,
        };
        if (this.state.status === 'add') {
            url = '/cm-sites-storage-management/face/label'
        } else {
            url = '/cm-sites-storage-management/face/editLabel';
            param.oldLabel = item.label.toString();
            if(!item.newlabel){
                param.label = item.oldLabel;
                item.newlabel = item.oldLabel
            }
        }

        if (item.newlabel && item.newlabel.length > 0 && item.newlabel[0].trim().length > 0) {
            this.request({
                url: url,
                method: 'POST',
                contentType: 'json',
                body: param,
                loading: true,
                callBack: async (data) => {
                    item.isShowInput = false;
                    this.setState({}, () => {
                        message.destroy();
                        message.success('人物名称设置成功！');
                        if(this.state.searchList&&this.state.searchList.length){
                            this.setState({dataSource:[]},()=>{
                                this.getSearchList();
                            });
                        }else{
                            this.setState({dataSource:[]},()=>{
                                this.getFaceList();
                            });
                        }
                        this.initProgress()
                    });
                }
            });
        } else {
            message.destroy();
            message.warn('请输入人物名称！');
        }
    };

    //以图搜图的接口
    getSearchList() {
        let {params} = this.state;
        params.image = this.state.searchList[0].originFileObj;
        let formData = new FormData();
        formData.append('labelId', params.labeled);
        formData.append('start', params.page);
        formData.append('size', "40"); //人脸图最多搜40张
        formData.append('image', params.image);
        this.request({
            url: '/cm-sites-storage-management/face/searchImgList',
            method: 'post',
            body: formData,
            contentType: 'upload',
            loading:true,
            callBack: async (data) => {
                let array = [];
                if (data) {
                    array = data.list;
                    this.setState({total: data.total, dataSource: array},()=>{
                        window.loading.hide();
                    })
                }
            }
        });
    }

}
